<template>
  <div>
    <headers></headers>
    <!--<carousel></carousel>-->
    <p class="banner padding88"><img :src="sliderImg" alt="" height="200px" width="100%"></p>
<!--    <div class="divider ">-->
<!--      <div class="auto">-->
<!--        <router-link to="/">首页</router-link><span>></span>行业学院-->
<!--      </div>-->
<!--    </div>-->
    <div class="navs">
      <div class="auto">
        <div class="title">
          <div class="pull-l">
            <li :class="{active:0===nowIndex}"  @click="tab('global',0)"><router-link to="/global" class="font14">项目介绍</router-link></li>
            <li :class="{active:1===nowIndex}"  @click="tab('global2',1)"><router-link to="/global2" class="font14">经典案例</router-link></li>
          </div>
        </div>
      </div>
    </div>
    <div class="auto padding250">
      <div class="auto">
        <div class="container clearfix font14" v-html=html style="text-align: left;">
        </div>
      </div>
    </div>
    <Spin fix v-show="isSpinShow" >
      <div class="loader">
        <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
        <div class="font14">加载中...</div>
      </div>
    </Spin>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  /* 旋转效果 */
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50% { transform: rotate(180deg);}
    to { transform: rotate(360deg);}
  }
  /* 假如内容过长，一屏放不下，滚动条下拉覆盖不全 */
  .ivu-spin-fix {
    position: fixed;
  }

  .divider{
    height: 53px;
    background-color: #fff;
    font-size: 14px;
    color: #957960;
    line-height: 53px;
    text-align: left;
    margin-bottom: 30px;
    box-shadow: 5px 1px 10px #ccc;
    a{
      color: #957960;
      &:hover{
        color: #9C7649;
        font-weight: 700;
      }
    }
    span{
      margin: 0 10px;
    }
  }
  form{
    width: 360px;
    margin:50px  0 0 50px ;
  }

  .navs{
    background-color: #fff;
    box-shadow: 5px 1px 10px #ccc;
    margin-bottom: 50px;
  }
  pull-l{
    margin-left: 5px;
    li:last-child{
      font-size: 14px;
      margin-top: 10px;
      img{
        vertical-align: sub;
      }
      a{
        color: #0089c4;

      }
    }
  }
  .title{
    font-size: 18px;
    color: #000;
    padding: 15px 1px 15px 0;
    text-align: left;
    li{
      display: inline-block;
      margin-right: 10px;
      a{
        padding: 5px 5px 15px;
        font-size: 18px;
        color: #666666;
      }
    }
    li.active {
      a{
        font-weight: 700;
        color: #957960;
      //  background-color: #957960;
      //  padding:10px 20px;
        //border-bottom: 3px solid #957960;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }


  //.title{
  //  font-size: 20px;
  //  color: #000;
  //  margin: 20px 0 25px 0;
  //  text-align: left;
  //  padding: 15px 20px ;
  //  background-color: #fff;
  //}
  .sex .ivu-form-item-content{
    text-align: left;
  }
  .ceping_form .ivu-date-picker{
    width: 250px;
  }
  .container {
    background-color: #fff;
    padding: 0px 41px;
    line-height: 30px;
  }
  /* 关键修改4：内容区样式调整 */
  .content-wrap {
    width: 100%;
  }
  .content-area {
    background-color: #fff;
    padding: 0px 41px;
    line-height: 30px;
    min-height: 600px; /* 新增：防止内容区高度为0时蒙层看不见 */
    position: relative; /* 核心：作为蒙层的定位参考 */
  }

  /* 关键修改5：加载蒙层样式，仅覆盖content-area */
  .content-loading {
    position: absolute; /* 绝对定位 */
    magin-top:  5px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8); /* 半透明白色遮罩 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10; /* 确保蒙层在内容上方 */
  }
  /* 加载动画容器样式优化 */
  .loader {
    background: #fff;
    padding: 20px 40px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  /* 移除原有的全屏fixed样式 */
  /deep/ .ivu-spin-fix {
    position: static !important;
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
  import carousel from '../template/carousel'
  import {getStore} from "../../storage";
  import {getHtmlWeb,sliderPC} from '../../http'
  export default {
    name: '',
    props: {},
    data() {
      return {
        nowIndex:0,           //视频类别选择
        html:'',
        sliderImg:'',
        isSpinShow:false,
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(newRoute) {
          // 从路由路径中提取tab标识（如 college、college2 等）
          const tabKey = newRoute.path.split('/').pop();
          // 映射tabKey到对应的索引
          const tabIndexMap = {
            'global': 0,
            'global2': 1
          };
          this.nowIndex = tabIndexMap[tabKey] || 0;
          this.loadContent(tabKey);
        }
      }
    },
    methods: {
      loadContent(tabKey) {
        // 映射tabKey到后端需要的type值
        const typeMap = {
          'global': 'gjjy',
          'global2': 'gjjy-2'

        };
        const type = typeMap[tabKey] || 'global';
        this.getZhuanhuan(type);
      },
      loadBanner(){
        //获取封面图
        sliderPC({sliderType:'10'}).then(res =>{
          this.sliderImg = res.data.slider.sliderImg;
        }).catch()
      },
      getZhuanhuan(type) {
        if (this.isSpinShow === false) {
          this.isSpinShow = true;
          //获取页面
          getHtmlWeb({type: type}).then(res => {
            this.isSpinShow = false;
            this.html = res.data.html.htmlContent;
          }).catch()
        }
      },

      //课程排序切换
      tab(type,index){
        this.nowIndex = index;
        this.sortOrder = 'S' + index;
        this.pageNumber = 1;
        this.getZhuanhuan(type);
      },
    },
    created() {
      this.loadBanner();
      this.getZhuanhuan('gjjy')
    },
    components: {
      headers,
      footers,
      carousel
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/other/global.vue